<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner">
      <white-menu ref="whiteMenu"></white-menu>
    </div>
    <!--watch detail content-->
    <div class="wathch-content" @click="handleCloseMenu">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="watch-img">
              <a class="big-photo big-photo-width">
                <img
                  :src="goodsBigPhoto"
                  alt="big"
                  class="img-responsive"
                  style="width: 650px;height: 650px;"
                />
              </a>
              <div class="page-bg">
                <a
                  href="#"
                  v-for="(page,i) in pics"
                  :key="i"
                  class="page-padding"
                  @mouseenter="handleShowBigPhoto(i)"
                >
                 <img
                    :src="pageIndex==i?require('../assets/icon/Line 17.png'):require('../assets/icon/Line 18.png')"
                    alt
                  />
                </a>
              </div>
              <a class="des-small right" v-for="(pic,i) in pics" :key="i">
                <img :src="pic" alt="small" @mouseenter="handleShowBigPhoto(i)" />
              </a>
            </div>
          </div>
          <div class="col-md-6 watch-info">
            <div class="breadcrumb white">
              <a class="mr-1" href="/">Home</a>
              &#62;
              <a class="ml-1 mr-1" href="/watchlist">{{goods.brandName}}</a>
              &#62;
              {{goods.seriesName}}
            </div>
            <div class="prd-brand f_kelly-R">
              {{goods.brandName}}
              <span class="page-icon">
                <!-- <i class="icons share-icon"></i> -->
                <span class="icons like" :class="{'active': goods.isWish}" aria-hidden="true" title="wish list" @click="addWish(goods.goodsId, goods.isWish)"></span>
              </span>
            </div>
            <h1 class="f_spec-B">{{goods.goodsName}}</h1>
            <p class="sku-info f_kelly-R">
              REF 8880GRANDEDATEBLVOG
              <br />
              {{goods.serialNumber}}
            </p>
            <p class="other-info">
              Condition:
              <span v-if="goods.goodsStatus && goods.goodsStatus===1">Unworn</span>
              <span v-if="goods.goodsStatus && goods.goodsStatus===2">Very Good</span>
              <span v-if="goods.goodsStatus && goods.goodsStatus===3">Good</span>
              <span v-if="goods.goodsStatus && goods.goodsStatus===4">Fair</span>
              <span v-if="goods.goodsStatus && goods.goodsStatus===5">Poor</span>
              <span v-if="goods.goodsStatus && goods.goodsStatus===6">Incomplete</span>
              |
              <span
                v-if="goods.originalPapers && goods.originalPapers===1"
              >Original box | Original papers</span>
              <span v-if="goods.originalPapers && goods.originalPapers===2">Original box</span>
              <span v-if="goods.originalPapers && goods.originalPapers===3">Original papers</span>
            </p>
            <p class="other-info" v-if="goods.leaveYear">Year: {{goods.leaveYear}}</p>
            <p class="other-info" v-else>Year: Unknow</p>
            <p class="prd-price" v-if="goods.priceType && goods.priceType!=2 && goods.actualStatus !=2">
              <span
                class="new-price"
                v-if="goods.webPrice && goods.originalPrice!==goods.webPrice"
              >HK$ {{goods.webPrice}}</span>
              <span class="new-price" v-else>HK$ {{goods.originalPrice}}</span>
              <span
                class="old-price"
                v-if="goods.webPrice && goods.originalPrice!==goods.webPrice"
              >HK$ {{goods.originalPrice}}</span>
            </p>
            <p class="prd-price" v-else-if="goods.priceType && goods.priceType===2 && goods.actualStatus !=2 ">
              <span class="new-price" style="color: #111;">Negotiated Price</span>
            </p>
            <p class="prd-price" v-else-if="goods.actualStatus ===2 ">
              <span class="new-price" style="color: #111;">Comming Soon</span>
            </p>
            <div class="btnBox">
              <div class="btns" v-if="goods.priceType && goods.priceType!=2 && goods.actualStatus===1">
                <a
                  href="javascript:;"
                  class="btn btn-black btn-lg btn-block f_kelly-R"
                  @click="checkout()"
                >BUY NOW</a>
                <div style="margin:15px -16px;">
                  <div class="col-md-6">
                    <a href="javascript:;" class="btn btn-default btn-lg btn-block f_kelly-R">MAkE AN OFFER</a>
                  </div>
                  <div class="col-md-6">
                    <a href="javascript:;" class="btn btn-default btn-lg btn-block f_kelly-R">MAKE A TRADE</a>
                  </div>
                </div>
              </div>
              <div class="btns" v-else-if="goods.priceType && goods.priceType===2 && goods.actualStatus !=2">
                <a href="javascript:;" class="btn btn-black btn-lg btn-block f_kelly-R">MAkE AN OFFER</a>
                <div style="margin:15px -16px;">
                  <div class="col-md-12">
                    <a href="javascript:;" class="btn btn-default btn-lg btn-block f_kelly-R">CONTACT OUR CLIENT ADVISOR</a>
                  </div>
                </div>
              </div>
              <div class="btns" v-else-if="goods.priceType && goods.priceType !=2 && goods.actualStatus ===3">
                <a href="javascript:;" class="btn btn-black btn-lg btn-block f_kelly-R">MAkE AN OFFER</a>
                <div style="margin:15px -16px;">
                  <div class="col-md-12">
                    <a href="javascript:;" class="btn btn-default btn-lg btn-block f_kelly-R">CONTACT OUR CLIENT ADVISOR</a>
                  </div>
                </div>
              </div>
              <div class="btns" v-else-if=" goods.actualStatus ===2">
                <a href="javascript:;" class="btn btn-black btn-lg btn-block f_kelly-R" @click="addWish(goods.goodsId, false)">ADD TO WISHLIST</a>
                <div style="margin:15px -16px;">
                  <div class="col-md-12">
                    <a href="javascript:;" class="btn btn-default btn-lg btn-block f_kelly-R">CONTACT OUR CLIENT ADVISOR</a>
                  </div>
                </div>
              </div>
              <p class="other-info top">Maintenance begin: {{goods.maintenancePeriodBegin}}</p>
              <p class="other-info">Maintenance end: {{goods.maintenancePeriodEnd}}</p>
            </div>
          </div>
        </div>

        <div class="row features">
          <div class="col-md-3 text-center">
            <h2 class="f_spec_sc-B">Features</h2>
          </div>
          <div class="col-md-9">
            <ul>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon1 pull-left"></i>
                </div>
                <div class="pull-left">
                  <h3>Dial</h3>
                  <p>{{goods.dialColor ? goods.dialColor: "Unknow"}}   {{goods.dialType}}</p>
                </div>
              </li>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon2 pull-left"></i>
                </div>
                <div class="pull-left">
                  <h3>Case Size</h3>
                  <p>{{goods.caseSize ? goods.caseSize: "Unknow"}}</p>
                </div>
              </li>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon3 pull-left"></i>
                </div>
                <div class="pull-left">
                  <h3>Case Material </h3>
                  <p>{{goods.caseMaterial ? goods.caseMaterial: "Unknow"}}</p>
                </div>
              </li>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon4 pull-left"></i>
                </div>
                <div class="pull-left">
                 <h3>Strap/Bracelet</h3>
                 <p>{{goods.braceletColor ? goods.braceletColor: "Unknow"}}   {{goods.braceletLength}}   {{goods.braceletMaterial}}</p>
                </div>
              </li>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon5 pull-left"></i>
                </div>
                <div class="pull-left">
                 <h3>Movement</h3>
                 <p>{{goods.movement ? goods.movement: "Unknow"}}</p>
                </div>
              </li>
              <li class="col-md-4 features-item">
                <div class="pull-left">
                  <i class="icons features-icon6 pull-left"></i>
                </div>
                <div class="pull-left">
                 <h3>Water Resistance </h3>
                 <p>{{goods.waterResistance ? goods.waterResistance: "Unknow"}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="row row-padding">
          <div class="col-md-7 col-md-7-width">
            <div class="description">
              <h2 class="info-title f_spec_sc-B">Description</h2>
              <p v-html="goods.detail"></p>
            </div>

            <div class="auth">
              <h2 class="info-title f_spec_sc-B">Authenticity Guarantee</h2>
              <div class="auth-item auth-item-padding">
                <img :src="require('@/assets/xh/images/menuprd1.png')" alt class="pull-left" />
                <p>
                  Lörem ipsum befärade diss dekavitäning. Bölogi tesa biod. Ben epissa. Ekack dopuvahet geotäna.
                  Fasade agnostigen. Soning blockkedja. Agevis kristofobi. Fare il, hexajor.
                </p>
              </div>
              <div class="auth-item auth-item-padding">
                <img :src="require('@/assets/xh/images/menuprd1.png')" alt class="pull-right" />
                <p>
                  Lörem ipsum befärade diss dekavitäning. Bölogi tesa biod. Ben epissa. Ekack dopuvahet geotäna.
                  Fasade agnostigen. Soning blockkedja. Agevis kristofobi. Fare il, hexajor.
                </p>
              </div>
              <div class="auth-item auth-item-padding">
                <img :src="require('@/assets/xh/images/menuprd1.png')" alt class="pull-left" />
                <p>
                  Lörem ipsum befärade diss dekavitäning. Bölogi tesa biod. Ben epissa. Ekack dopuvahet geotäna.
                  Fasade agnostigen. Soning blockkedja. Agevis kristofobi. Fare il, hexajor.
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-5 details col-md-7-width row-right-flex">
            <div class="details-item">
              <h2 class="info-title f_spec_sc-B">Details</h2>
              <h3 class="info-title2 f_spec_sc-B">WATCH INFO</h3>

              <p>
                <span class="details-title">Reference Number:</span> {{goods.referenceCode && goods.referenceCode.slice(0,10)}}.....
              </p>
              <p>
                <span class="details-title">SKU:</span> {{goods.serialNumber}}
              </p>
              <p>
                <span class="details-title">Year:</span> {{goods.leaveYear ? goods.leaveYear: "Unknown"}}
              </p>
              <p>
                <span class="details-title">Manufactured In:</span> {{goods.originCountry ? goods.originCountry: "Unknown"}}
              </p>
             <p v-if="goods.originalPapers && goods.originalPapers===1"><span class="details-title">Certificates:</span> Original box &amp; Original papers</p>
             <p v-if="goods.originalPapers && goods.originalPapers===2"><span class="details-title">Certificates:</span> Original box</p>
             <p v-if="goods.originalPapers && goods.originalPapers===3"><span class="details-title">Certificates:</span> Original papers</p>
             <p v-if="goods.originalPapers===null"><span class="details-title">Certificates:</span> Unknow</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===1"><span class="details-title">Condition:</span>	Unworn</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===2"><span class="details-title">Condition:</span>	Very Good</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===3"><span class="details-title">Condition:</span>	Good</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===4"><span class="details-title">Condition:</span>	Fair</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===5"><span class="details-title">Condition:</span>	Poor</p>
             <p v-if="goods.goodsStatus && goods.goodsStatus===6"><span class="details-title">Condition:</span>	Incomplete</p>
             <p><span class="details-title">Gender:</span> Mens</p>
              <p>
                <span class="details-title">Complications:</span> Date, Day, Month
              </p>
              <p>
                <span class="details-title">Price:</span> €1,550 (= HK$12,195)
              </p>
              <p v-if="goods.actualStatus===1">
                <span class="details-title">Availability:</span> Available now
              </p>
              <p v-if="goods.actualStatus===2">
                <span class="details-title">Availability:</span> Available now
              </p>
              <p v-if="goods.actualStatus===1">
                <span class="details-title">Availability:</span> Available now
              </p>
            </div>
            <div class="details-item">
              <h3 class="info-title2 f_spec_sc-B">CASE &amp; DIAL</h3>
              <p>
                <span class="details-title">Case Size:</span> {{goods.caseSize ? goods.caseSize: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Case Material:</span> {{goods.caseMaterial  ? goods.caseMaterial: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Case Shape:</span> {{goods.caseShape  ? goods.caseShape: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Caseback:</span> {{goods.caseBack  ? goods.caseBack: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Dial Color:</span> {{goods.dialColor  ? goods.dialColor: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Dial Style:</span> {{goods.dialType  ? goods.dialType: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Bezel material:</span> {{goods.bezelMaterial  ? goods.bezelMaterial: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Crystal:</span> {{goods.crystal  ? goods.crystal: "Unknow"}}
              </p>
              <p>
                <span class="details-title">Water Resistance:</span> {{goods.waterResistance  ? goods.waterResistance: "Unknow"}}
              </p>
            </div>
            <div class="details-item">
              <h3 class="info-title2 f_spec_sc-B">CALIBER</h3>
              <p>
                <span class="details-title">Movement:</span> {{goods.movement ? goods.movement:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Power reserve:</span> {{goods.powerReserve ? goods.powerReserve:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Number of jewels:</span> {{goods.numberJewels ? goods.numberJewels:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Frequency:</span> {{goods.frequency ? goods.frequency:'Unknow'}}
              </p>
            </div>

            <div class="details-item">
              <h3 class="info-title2 f_spec_sc-B">STRAP/BRACELET</h3>
              <p>
                <span class="details-title">Strap/Bracelet Material:</span>{{goods.braceletMaterial?goods.braceletMaterial:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Strap/Bracelet Color:</span> {{goods.braceletColor?goods.braceletColor:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Buckle Type:</span> {{goods.buckleType?goods.buckleType:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Strap/Bracelet Length:</span> {{goods.braceletLength?goods.braceletLength:'Unknow'}}
              </p>
              <p>
                <span class="details-title">Lug width (in-between lug):</span> {{goods.lugWidth?goods.lugWidth:'Unknow'}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Warranties    -->
    <div class="warranties">
      <h1 class="title f_spec_sc-R">
        <div class="container">Warranties</div>
      </h1>
      <div class="container">
        <ul class="content row">
          <li class="col-md-4">
            <div class="item">
              <img :src="require('@/assets/xh/images/warranties-icon.png')" alt />
              <h3 class="f_spec-B">Authenticity Guarantee</h3>
              <p>
                Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben.
                Mast blorange geotaggning. Tesk triren i luk nimisk.
              </p>
            </div>
          </li>
          <li class="col-md-4">
            <div class="item">
              <img :src="require('@/assets/xh/images/warranties-icon.png')" alt />
              <h3 class="f_spec-B">Authenticity Guarantee</h3>
              <p>
                Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben.
                Mast blorange geotaggning. Tesk triren i luk nimisk.
              </p>
            </div>
          </li>
          <li class="col-md-4">
            <div class="item">
              <img :src="require('@/assets/xh/images/warranties-icon.png')" alt />
              <h3 class="f_spec-B">Authenticity Guarantee</h3>
              <p>
                Lörem ipsum plamis heterotodade pas. Spebel fängen. Infraskapet ben.
                Mast blorange geotaggning. Tesk triren i luk nimisk.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!--MAY  LIKE-->
    <div class="may-like">
      <h1 class="f_spec_sc-R text-center">You May Also Like</h1>
      <ul class="container">
        <div class="swiper-container like-list" ref="likeListSwiper">
          <div class="swiper-wrapper">
            <ul class="swiper-slide" v-for="(list,index) in guessLikePages" :key="index">
              <li class="like-item" v-for="(item,i) in list" :key="i">
                <div class="prd-item">
                  <a href="javascript:;" @click="tiaozhuan(item.goodsId)">
                    <div class="prd-img">
                      <img :src="item.picUrl" class="img-responsive" alt />
                    </div>
                    <b class="prd-brand">{{ item.brandName }}</b>
                    <p class="prd-name">{{ item.goodsName }}</p>
                    <span class="prd-price">$ {{ item.originalPrice}}</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </ul>
     <div class="swiper-button-next black-next"></div>
      <div class="swiper-button-prev black-prev"></div>
    </div>

    <div class="comment">
      <h1 class="f_spec_sc-B text-center">What thousands of happy customers are saying about us</h1>
      <div class="more-links f_kelly-R container">
        <a href="#/watchlist">View All</a>
      </div>
      <div class="swiper-container comment-container" ref="commentSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide"></div>
          <div class="swiper-slide comment-item" v-for="(item, index) in commentList" :key="index">
            <div class="buyer-info">
              <div class="avtar pull-left">{{ item.avtar }}</div>
              <p class="name">{{ item.name }}</p>
              <p class="city">{{ item.city }}</p>
              <p class="clearfix"></p>
            </div>
            <div class="stars text-right">
              <span
                class="glyphicon glyphicon-star"
                :class="[item.rating > 0 ? 'white' : '' ]"
                aria-hidden="true"
              ></span>
              <span
                class="glyphicon glyphicon-star"
                :class="[item.rating > 1 ? 'white' : '' ]"
                aria-hidden="true"
              ></span>
              <span
                class="glyphicon glyphicon-star"
                :class="[item.rating > 2 ? 'white' : '' ]"
                aria-hidden="true"
              ></span>
              <span
                class="glyphicon glyphicon-star"
                :class="[item.rating > 3 ? 'white' : '' ]"
                aria-hidden="true"
              ></span>
              <span
                class="glyphicon glyphicon-star"
                :class="[item.rating > 4 ? 'white' : '' ]"
                aria-hidden="true"
              ></span>
            </div>
            <div class="comment-content">
              <div class="l-symbol">“</div>
              <div class="comment-words">{{ item.commentWords}}</div>
              <div class="r-symbol">”</div>
            </div>
            <p class="date text-right">{{ item.date }}</p>
          </div>
        </div>
        <!-- Add Scrollbar -->
        <div class="swiper-scrollbar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import WhiteMenu from "@/components/WhiteMenu";
import Swiper, { Navigation, Pagination } from "swiper";
import { goodsList, addGoodsCar, goodsListByGoodsIdAndWish } from "@/api/index";
import {addOrUpdateWish,guessYourLove} from '@/api/watchList';
import { setBuy, getBuy } from "../utils/auth";
export default {
  name: "WatchPage",
  components: {
    WhiteMenu
  },
  data() {
    return {
      goods: {
        brandName: undefined,
        goodsName: undefined,
        seriesName: undefined,
        serialNumber: undefined,
        originalPrice: undefined,
        webPrice: undefined,
        goodsStatus: undefined,
        originalBox: undefined,
        originalPapers: undefined,
        detail: undefined,
        leaveYear: undefined,
        maintenancePeriodEnd: undefined,
        maintenancePeriodBegin: undefined,
        goodsId: undefined,
        picUrl: undefined
      },
      pics: [
        require("@/assets/xh/images/watch1.png"),
        require("@/assets/xh/images/watch2.png"),
        require("@/assets/xh/images/watch3.png"),
        require("@/assets/xh/images/watch4.png")
      ],
      goodsBigPhoto: "",
      pageIndex: 0,
      guessLikeList: [],
      guessLikePages: [],
      commentList: [],
    };
  },
  created() {
    var id = this.$route.query.id;
    console.log("得到参数" + id);
    if (id === undefined) {
      console.log("进来了");
      this.$router.push("/");
    }
    //根据id请求接口
    this.selectGoodsById(id);

    this.commentList = [
      {
        id: 1,
        avtar: "B",
        name: "Jaff B.",
        city: "Hong Kong SAR",
        rating: 5,
        date: "Jul 28, 2022",
        commentWords:
          "You guys rock. Made an unsettling process for a new buyer very easy and trustworthy. The guy who called me and handled delivery all the way until I had my timepiece was highly professional. I will certainly use watchbox again soon."
      },
      {
        id: 2,
        avtar: "A",
        name: "Jaff A.",
        city: "Hong Kong SAR",
        rating: 4,
        date: "Jul 28, 2022",
        commentWords:
          "You guys rock. Made an unsettling process for a new buyer very easy and trustworthy. The guy who called me and handled delivery all the way until I had my timepiece was highly professional. I will certainly use watchbox again soon."
      },
      {
        id: 3,
        avtar: "D",
        name: "Jaff D.",
        city: "Hong Kong SAR",
        rating: 3,
        date: "Jul 28, 2022",
        commentWords:
          "You guys rock. Made an unsettling process for a new buyer very easy and trustworthy. The guy who called me and handled delivery all the way until I had my timepiece was highly professional. I will certainly use watchbox again soon."
      },
      {
        id: 4,
        avtar: "B",
        name: "Jaff B.",
        city: "Hong Kong SAR",
        rating: 2,
        date: "Jul 28, 2022",
        commentWords:
          "You guys rock. Made an unsettling process for a new buyer very easy and trustworthy. The guy who called me and handled delivery all the way until I had my timepiece was highly professional. I will certainly use watchbox again soon."
      },
      {
        id: 5,
        avtar: "B",
        name: "Jaff B.",
        city: "Hong Kong SAR",
        rating: 1,
        date: "Jul 28, 2022",
        commentWords:
          "You guys rock. Made an unsettling process for a new buyer very easy and trustworthy. The guy who called me and handled delivery all the way until I had my timepiece was highly professional. I will certainly use watchbox again soon."
      }
    ];

    return
    this.guessLikeList = [
      // {id:1, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      // {id:2, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      // {id:3, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      // {id:4, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      // {id:5, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
    ];

    let allGuessLikeList = [];
    let j = 0,
      k = 0;
    let guessList = [];
    for (let i = 0; i < allGuessLikeList.length; i++) {
      if (k == 5) {
        this.guessLikePages.push(guessList);
        guessList = [];
        k = 1;
      } else {
        k++;
      }
      guessList.push(allGuessLikeList[i]);
    }
    if (guessList.length > 0) {
      this.guessLikePages.push(guessList);
    }




  },
  mounted() {
    // new Swiper(this.$refs.likeListSwiper, {
    //   // configure Swiper to use modules
    //   modules: [Navigation, Pagination],
    //   // Optional parameters
    //   loop: true,
    //   slidesPerView: "auto",
    //   spaceBetween: 0,
    //   observer: true,
    //   observeParents: true,
    //   freeMode: true,
    //   // direction: "horizontal",
    //   // followFinger: true,
    //   mousewheel: true,
    //   // If we need pagination
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true
    //   },

    //   // Navigation arrows
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev"
    //   },

    //   // And if we need scrollbar
    //   // scrollbar: {
    //   //   el: '.swiper-scrollbar',
    //   // },
    //   on: {
    //     navigationNext: function(self) {
    //       console.log("navigation next", self.activeIndex);
    //     },
    //     navigationPrev: function(self) {
    //       console.log("navigation prev", self.activeIndex);
    //     }
    //   }
    // });

    console.log('comment list: ', this.commentList)
    new Swiper(this.$refs.commentSwiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      // loop: true,
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar"
      }
    });
  },
  methods: {
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu");
      if (!sp.contains(event.target)) {
        this.$refs.whiteMenu.searchFocus = false;
        this.$refs.whiteMenu.isHovered = false;
      }
    },
    tiaozhuan(id){
       this.$router.push({ path: 'watchpage', query: { id: id }}, () => {})
    },
    handleShowBigPhoto(i) {
      this.goodsBigPhoto = this.pics[i];
      this.pageIndex = i;
    },
    checkout() {
      console.log("跳转checkout");
      //加入购物车
      if (this.$store.getters.userId) {
        console.log("已登录");
        addGoodsCar({
          goodsId: this.goods.goodsId,
          userId: this.$store.getters.userId,
          picUrl: this.goods.picUrl,
          goodsName: this.goods.goodsName
        }).then(response => {
          console.log(response.data.data);
        });
      } else {
        console.log("未登录");
        var gid = getBuy();
        if (gid) {
          console.log(gid);
          console.log(this.goods.goodsId);
          if (!gid.includes(this.goods.goodsId)) {
            setBuy(gid + "," + this.goods.goodsId);
          }
        } else {
          setBuy(this.goods.goodsId);
        }
      }
      this.$router.push("/checkout");
    },
    addWish(goodsId, isWish){
     if(!this.$store.getters.userId){
       this.$router.push('/login')
     }else{
       let isNotWish = !isWish;
       addOrUpdateWish({userId:this.$store.getters.userId,goodsId:goodsId,addOrUpdateSwitch:isNotWish}).then(res=>{
         console.log(res.data)
         // this.$message.success('加入成功')
         this.goods.isWish = isNotWish
       })
     }
    },
    selectGoodsById(goodsId) {
      let userId = this.$store.getters.userId || 0;
      goodsListByGoodsIdAndWish({ goodsId: goodsId, userId: userId }).then(response => {
        console.log("===");
        console.log(response.data.data);
        if (response.data.data.total == 0) {
          return;
        }
        const goods = response.data.data.list[0];
        this.goods = goods;
        var goodsPic = [];
        goodsPic.push(goods.picUrl);
        console.log(goodsPic);
        if (goods.galleryBig) {
          var bigPic = goods.galleryBig.split(",");
          goodsPic = goodsPic.concat(bigPic);
        }
        this.pics = goodsPic;
        console.log("得到结果");
        console.log(goodsPic);
        if (this.pics.length > 0) {
          this.goodsBigPhoto = this.pics[0];
        }
        //猜你喜欢
        var keyword=localStorage.getItem('keyword')
        var aa=[]
        if(keyword){
           aa=keyword.split(',')
        }
        console.log(aa)
        var obj={}
        obj.brandId=this.goods.brandId
        obj.seriesId=this.goods.seriesId
        obj.goodsId=goodsId
        obj.keyword=keyword
        guessYourLove(obj)
        .then(res=>{
          console.log('猜你喜欢')
          console.log(res.data)
          let allGuessLikeList = res.data.data;
          let j = 0, k = 0;
          let guessList = [];
          for (let i = 0; i < allGuessLikeList.length; i++) {
            if (k == 5) {
              this.guessLikePages.push(guessList);
              guessList = [];
              k = 1;
            } else {
              k++;
            }
            guessList.push(allGuessLikeList[i]);
          }
          if (guessList.length > 0) {
            this.guessLikePages.push(guessList);
          }
          console.log(this.guessLikePages)
          this.$nextTick(() => {
            this.likeSwiperInit()
          })

        }).catch(err => {
          console.log(err)
        })
      }).catch(error => {
        console.log(error)
      });
    },
    likeSwiperInit() {
      new Swiper(this.$refs.likeListSwiper, {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        // Optional parameters
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        freeMode: true,
        // direction: "horizontal",
        // followFinger: true,
        mousewheel: true,
        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },

        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },

        // And if we need scrollbar
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        // },
        on: {
          navigationNext: function(self) {
            console.log("navigation next", self.activeIndex);
          },
          navigationPrev: function(self) {
            console.log("navigation prev", self.activeIndex);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
  @import url("../assets/xh/css/bootstrap.min.css");
  @import url("../assets/xh/css/swiper.min.css");
  @import url("../assets/xh/css/reset.css");
  @import url("../assets/xh/css/watchpage.css");
  @import url("../assets/xh/css/watches.css");
  @import url("../assets/xh/css/fonts.css");

  .watch-info .prd-brand {
    display: flex;
    justify-content: space-between;
    width: 60%;
  }
  .prd-brand .page-icon {
    display: flex;
    align-items: center;
  }
  .prd-brand .page-icon span {
    display: flex;
  }
  .watch-info .like {
      top: 50px;
      right: 20px;
      cursor: pointer;
      width: 32px;
      height: 32px;
      background-position: -256px -32px;
      -webkit-transition: none;
      transition: none;
  }
  .watch-info .like.active {
      background-position: -288px -32px;
  }
.page-bg {
  width: 77%;
  height: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
}
.page-padding {
  padding: 10px;
}
.auth-item-padding {
  padding: 0px;
}
.white {
  background-color: white;
}
.btnBox {
  width: 60%;
}
.col-md-7-width {
  width: 50%;
  max-width: 50%;
}
.top {
  margin-top: 85px;
}
.right {
  margin-right: 60px;
}
.row-padding {
  padding-left: 6%;
  padding-right: 6%;
}
.row-right-flex {
  flex: 1;
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/WatchPageView.vue